import { useQueryState } from 'nuqs'
import { useState } from 'react'

import { isValidGTIN } from '@/lib/utils'

export type SearchType = 'gtin' | 'term'

export function useProductFinderState() {
  const [activeSearchTerm, setActiveSearchTerm] = useQueryState('term', { history: 'push' })
  const [searchInputValue, setSearchInputValue] = useState(activeSearchTerm ?? '')
  const [showHistory, setShowHistory] = useState(false)

  const searchType: SearchType = activeSearchTerm && isValidGTIN(activeSearchTerm) ? 'gtin' : 'term'

  function commitSearch(term: string) {
    setActiveSearchTerm(term)
    setSearchInputValue(term)
    setShowHistory(false)
  }

  function reset() {
    setActiveSearchTerm(null)
    setSearchInputValue('')
    setShowHistory(true)
  }

  return {
    searchInputValue: searchInputValue,
    setSearchInputValue,
    activeSearchTerm: activeSearchTerm ?? undefined,
    commitSearch,
    searchType,
    reset,
    showHistory,
    setShowHistory,
  }
}
